// extracted by mini-css-extract-plugin
export default {"form":"styles_form__F+SZc","buttons":"styles_buttons__OiZ9w","submit":"styles_submit__lvuGj","cancel":"styles_cancel__M5h-s"};